var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M13.3555 8C10.7055 8 8.30547 8.99 6.45547 10.6L2.85547 7V16H11.8555L8.23547 12.38C9.62547 11.22 11.3955 10.5 13.3555 10.5C16.8955 10.5 19.9055 12.81 20.9555 16L23.3255 15.22C21.9355 11.03 18.0055 8 13.3555 8Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
